export const STOREFRONT_API_VERSION = '2024-04';
